import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import NavLinks from '../components/NavLinks';
import JoinButton from '../components/JoinButton';
import { navigationConfig } from '../data/navigationData';

const MobileNav = ({ 
  currentPage,
  isOpen,
  toggleMenu,
  onLinkClick,
  className = ''
}) => {
  const [homeExpanded, setHomeExpanded] = useState(false);
  const { homeDropdown } = navigationConfig;
  const navigate = useNavigate();
  const location = useLocation();

  const handleHomeClick = (e) => {
    e.preventDefault();
    setHomeExpanded(!homeExpanded);
  };

  const handleSectionClick = (sectionId) => {
    // If not on home page, navigate to home first, then scroll to section
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation and DOM update, then scroll to section
      // Use a longer timeout to ensure the page has loaded
      setTimeout(() => {
        const scrollToSection = () => {
          const section = document.getElementById(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          } else {
            // If section not found yet, try again after a short delay
            setTimeout(scrollToSection, 100);
          }
        };
        scrollToSection();
      }, 300);
    } else {
      // Already on home page, just scroll to section
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
    toggleMenu(); // Close menu after clicking
  };

  const handleLinkClickInternal = () => {
    if (onLinkClick) onLinkClick();
    toggleMenu(); // Close menu after clicking
  };

  if (!isOpen) return null;

  return (
    <div className={`mobile-nav-container ${className}`}>
      <nav className="mobile-nav" role="navigation" aria-label="Main navigation">
        <ul className="nav-listt">
          {/* Home Accordion */}
          <li className="nav-itemm">
            <div className={`accordion-item ${homeExpanded ? "expanded" : ""}`}>
              <button
                type="button"
                className={`accordion-header ${currentPage === 'home' ? 'active' : ''}`}
                onClick={handleHomeClick}
                aria-expanded={homeExpanded}
                aria-controls="home-dropdown"
                aria-label="Home menu"
              >
                Home <span className="dropdown-arrow" aria-hidden="true">&#9662;</span>
              </button>
              {homeExpanded && (
                <ul className="accordion-content" id="home-dropdown" role="menu">
                  {homeDropdown.map((item, index) => (
                    <li key={index} role="menuitem">
                      <button
                        type="button"
                        className="accordion-link"
                        onClick={() => handleSectionClick(item.sectionId)}
                      >
                        {item.name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </li>

          {/* Regular Navigation Links */}
          <NavLinks 
            currentPage={currentPage}
            variant="mobile"
            onLinkClick={handleLinkClickInternal}
          />

          {/* Join Us Button */}
          <li className="nav-itemm">
            <JoinButton 
              variant="mobile"
              onClick={handleLinkClickInternal}
            />
          </li>
        </ul>
      </nav>

      <button 
        className="close-icon"
        onClick={toggleMenu}
        aria-label="Close menu"
      >
        ✕
      </button>
    </div>
  );
};

export default MobileNav;